import { Component, Input, OnInit } from '@angular/core';
import { Offer } from '../../models/offer.model';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { PricesService } from '../../service/prices.service';

@Component({
    selector: 'app-order-view',
    templateUrl: './order-view.component.html',
    styleUrls: ['./order-view.component.scss'],
    standalone: false
})
export class OrderViewComponent implements OnInit {

  @Input() order: Offer;
  @Input() showDiscounts = false;
  @Input() showVAT = false;

  constructor(
    private breadcrumbService: BreadcrumbService,
    public pricesService: PricesService
  ) {
    this.breadcrumbService.setItems([
      {label: 'Order'}
    ]);
  }

  print() {
    window.print();
  }

  ngOnInit(): void {
    // this.offer.dateCreated = new Date(this.offer.dateCreated + 'Z');
  }
}
